import { getMovieTrailerOtt } from '../utils/get-movie-trailer-ott';

import { useReadMovieTrailerPlayerBaseInfo } from './use-read-movie-trailer-player-base-info';

export function useMovieTrailerOtt(contentId: string) {
    const trailer = useReadMovieTrailerPlayerBaseInfo(contentId);

    return trailer ? getMovieTrailerOtt(trailer) : undefined;
}
